import {io, Socket} from 'socket.io-client';
import {StorageManagerGateway} from '../../core-logic/gateways/app-services/storage-manager-gateway';
import {LoyaltyCardModel} from '../../core-logic/models/loyalty-card/loyalty-card-model';
import {UserModel} from '../../core-logic/models/user/user-model';
import {environment} from '../../../environments/environment';
import * as _ from 'lodash';
import {NavController} from '@ionic/angular';
import {take} from 'rxjs/operators';
import {StorageLoyaltiesCardsManagerService} from './storage-loyalties-cards-manager.service';
import {BusinessModel} from '../../core-logic/models/business/business-model';
import {Observable, Subject} from 'rxjs';
import {StorageBusinessesManagerService} from './storage-businesses-manager.service';
import {BusinessIdMemberId} from '../../core-logic/models/shared/business-id-member-id';
import {TagModel} from '../../core-logic/models/tag/tag-model';
import {NotificationModel} from '../../core-logic/models/notification/notification-model';
import {NotificationManagerService} from './notification-manager.service';
import {WheelGameResultModel} from '../../core-logic/models/wheel-game/wheel-game-model';

export interface BusinessIdSold {
  businessId: string;
  sold: number;
}
export class SocketIoService {
  private soldSubject = new Subject<BusinessIdSold>();
  private wheelResultSubject = new Subject<WheelGameResultModel>();
  private readonly errorMessage = 'not authorized';
  private currentUser: UserModel;
  private socketClient: Socket;

  constructor(private navCtrl: NavController,
              private storageManager: StorageManagerGateway,
              private notificationManagerService: NotificationManagerService,
              private storageLoyaltiesCardsManagerService: StorageLoyaltiesCardsManagerService,
              private storageBusinessesManagerService: StorageBusinessesManagerService) {}

  initConnection() {
    this.storageManager.getCurrentUser().subscribe( currentUser => {
      this.currentUser = currentUser as UserModel;
      this.socketClient = io(environment.fydlApi.url, {auth: {token: this.currentUser?.token} });
      this.socketClient.on('connect', () => { console.log(this.socketClient.id); });
      this.socketClient.on('connect_error', (error) => {
        if (_.isEqual(this.errorMessage, error.message )) {
          this.storageManager.clear().subscribe(() => {
            this.close();
            this.navCtrl.navigateRoot('/log-in');
          });
        }
      });
      this.initLoyaltiesCardsListeners();
      this.initBusinessesListeners();
      this.initNotificationListener();
      this.initBusinessSoldUpdate();
      this.initWheelResultsUpdate();
    });
  }

  listenBusinessSoldUpdate(): Observable<BusinessIdSold> {
    return this.soldSubject.asObservable();
  }

  listenWheelResultUpdate(): Observable<WheelGameResultModel> {
    return this.wheelResultSubject.asObservable();
  }

  close() {
    this.storageLoyaltiesCardsManagerService.reset();
    this.socketClient.disconnect();
  }

  isItActive(): boolean {
    return this.socketClient && this.socketClient.active;
  }

  private initBusinessSoldUpdate() {
    this.socketClient.on('updated_business_sold', (businessIdAndSold) => {
      this.soldSubject.next(businessIdAndSold as BusinessIdSold)
    });
  }
  private initWheelResultsUpdate() {
    this.socketClient.on('updated_wheel_result', (wheelResult) => {
      this.wheelResultSubject.next(wheelResult as WheelGameResultModel)
    });
  }

  private initLoyaltiesCardsListeners() {
    // this.socketClient.on('loyalties_cards', (loyaltiesCardsFromSocket) => {
    //   const loyaltyCardModels: LoyaltyCardModel[] = loyaltiesCardsFromSocket as LoyaltyCardModel[];
    //   // this.storageLoyaltiesCardsManagerService.init(loyaltyCardModels);
    // });
    this.socketClient.on('loyalty_card', (loyaltyCardFromSocket) => {
      this.storageManager.getCurrentUser().subscribe(currentRefreshedUser => {
        this.currentUser = currentRefreshedUser;
        const loyaltyCardModel: LoyaltyCardModel = loyaltyCardFromSocket as LoyaltyCardModel;
        this.refreshStoredUserLoyaltiesCard(loyaltyCardModel).pipe(take(1))
          .subscribe(() => this.storageLoyaltiesCardsManagerService.add(loyaltyCardModel));
      });
    });
  }

  private initBusinessesListeners() {
    this.socketClient.on('business', (businessFromSocket) => {
      const businessModel: BusinessModel = businessFromSocket as BusinessModel;
      this.storageBusinessesManagerService.refreshOrAddBusinessFromSocket(businessModel)
        .pipe(take(1)).subscribe();
    });
    this.socketClient.on('removed_business_member', (businessIdMemberIdFromSocket) => {
      const businessIdMemberId: BusinessIdMemberId = businessIdMemberIdFromSocket as BusinessIdMemberId;
      this.storageBusinessesManagerService.removeBusinessOfRemovedMemberFromSocket(businessIdMemberId).pipe(take(1)).subscribe();
    });
    this.socketClient.on('tag', (businessTagSocket) => {
      const businessTag: TagModel = businessTagSocket as TagModel;
      this.storageBusinessesManagerService.refreshBusinessTagFromSocket(businessTag).pipe(take(1)).subscribe();
    });
  }

  private initNotificationListener() {
    this.socketClient.on('notification', (notificationFromSocket) => {
      const notification = notificationFromSocket as NotificationModel;
      this.notificationManagerService.refreshNotifications(notification);
    });
  }

  private refreshStoredUserLoyaltiesCard(loyaltyCardModel: LoyaltyCardModel): Observable<boolean> {
    const loyaltyCardIndex = this.findLoyaltyCardIndexFromStoredUser(loyaltyCardModel);
    loyaltyCardIndex === -1 ? this.currentUser.loyalty_cards.push(loyaltyCardModel) :
      this.currentUser.loyalty_cards[loyaltyCardIndex] = loyaltyCardModel;
    return this.storageManager.setCurrentUser(this.currentUser);
  }

  private findLoyaltyCardIndexFromStoredUser(loyaltyCardModel: LoyaltyCardModel) {
    return this.currentUser.loyalty_cards
      .findIndex(loyaltyCardFound => loyaltyCardFound._id === loyaltyCardModel._id);
  }
}
